import { toast } from 'sonner';
import { moveItem } from '@/actions/pipeline';
import type { Pipeline, PipelineItem } from '@/reducers/pipelineReducer';
import type { ActionSheetItem } from '@/components/mobile';
import { cn } from '@/lib/utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Dispatch = (action: any) => any;

// Moves a card to the bottom of another column, the same way the item
// sheet's Status field does, and surfaces the automatic stage-change text.
export const moveItemToColumn = async (
	dispatch: Dispatch,
	item: PipelineItem,
	pipelineId: string,
	allItems: PipelineItem[],
	columnId: string
) => {
	if (columnId === item.columnId) return;
	const position = allItems.filter(
		(i) => i.columnId === columnId && i.status !== 'archived'
	).length;
	const result = await dispatch(
		moveItem(item._id, pipelineId, item.columnId, columnId, position)
	);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const stageSms = (result as any)?.stageSms;
	if (stageSms?.queued) {
		toast.success('Text message sent', {
			description: stageSms.customerName
				? `Sent to ${stageSms.customerName}`
				: 'The customer was notified',
		});
	}
};

// A column's colour dot, sized like an ActionSheet row icon.
const columnDot = (color?: string) => {
	const ColumnDot = ({ className }: { className?: string }) => (
		<span className={cn('flex items-center justify-center', className)}>
			<span
				className="size-3 rounded-full"
				style={{ backgroundColor: color || '#e2e8f0' }}
			/>
		</span>
	);
	return ColumnDot;
};

// The rows of a "Move to…" action sheet page: every column, the current one checked.
export const moveToColumnItems = (
	columns: Pipeline['columns'],
	currentColumnId: string | undefined,
	onMove: (columnId: string) => void
): ActionSheetItem[] =>
	columns.map((column) => ({
		id: column._id,
		label: column.name,
		icon: columnDot(column.color),
		checked: column._id === currentColumnId,
		onSelect: () => onMove(column._id),
	}));
